import { ajax } from '@fosterburg/common-ui/utils/ajax';
import { prefix } from './prefix';

export async function createContactForm(name: string, email: string, message: string) {
  const response = await ajax({
    method: 'post',
    url: prefix + '/contact-forms',
    data: {
      name,
      email,
      message,
    },
  });

  return response.ok;
}
